import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { OfflineUiService } from '@shared/services/offline/offline-ui.service';
import { NetworkStatusService } from '@shared/services/offline/network-status.service';

@Component({
  selector: 'avenir-offline-global-banner',
  templateUrl: './offline-global-banner.component.html',
  styleUrl: './offline-global-banner.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OfflineGlobalBannerComponent {
  private readonly ui = inject(OfflineUiService);
  private readonly networkStatus = inject(NetworkStatusService);

  readonly showBanner = this.ui.showGlobalBanner;
  readonly bannerMessage = this.ui.globalBannerText;
  readonly offlineTitle = $localize`:@@offlineGlobalBannerTitle:Offline Mode`;

  constructor() {
    if (typeof window !== 'undefined') {
      window.addEventListener('online', () => this.ui.refreshGlobalBanner());
      window.addEventListener('offline', () => this.ui.refreshGlobalBanner());
    }
  }
}
